import { makeStyles, Theme } from '@material-ui/core';
import { Modal, Typography } from '@thingsw/pitta-design-system';
import React from 'react';
import { useTranslation } from 'react-i18next/';

const useStyles = makeStyles((theme: Theme) => ({
  resetModal: {
    maxWidth: 343,
  },
  resetTitle: {
    padding: 16,
  },
  resetContent: {
    padding: '0 16px 16px',
  },
  modalBtn: {
    width: '100%',
  },
}));

interface EventTriggerRestAlertModalProps {
  open: boolean;
  onClose: () => void;
}

const EventTriggerRestAlertModal = ({
  open,
  onClose,
}: EventTriggerRestAlertModalProps) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      heading={t('Changing the speed_')}
      className={classes.resetModal}
      titleClassName={classes.resetTitle}
      contentClassName={classes.resetContent}
      RButtonClassName={classes.modalBtn}
      content={
        <Typography category='Default' variant='Body'>
          {t('Please reconfigure_')}
        </Typography>
      }
      fullWidthBtn
      RButton={t('OK')}
      onClickPositive={onClose}
    />
  );
};

export default EventTriggerRestAlertModal;
